import { useTranslation } from 'react-i18next';
import { reportCreatorI18n } from '../i18n';

const formatDate = (value) => {
  if (!value) return '--';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '--';
  return date.toLocaleDateString('es-CL');
};

const SavedReportsList = ({
  DesignSystemComponents,
  reports,
  loading,
  onLoadReport,
  page = 1,
  pageSize = 20,
  total = 0,
  search = '',
  onSearchChange,
  onPageChange,
}) => {
  const { Button, Input } = DesignSystemComponents ?? {};
  const { t } = useTranslation(undefined, { i18n: reportCreatorI18n });
  const totalPages = Math.max(
    1,
    Math.ceil(Number(total || 0) / Number(pageSize || 20))
  );
  const canGoPrev = page > 1;
  const canGoNext = page < totalPages;

  return (
    <div className='report-creator-panel'>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <h3 className='fw-semibold mb-0'>{t('rc_saved_title')}</h3>
        {loading && <span className='caption color-gray-600'>{t('rc_saved_loading')}</span>}
      </div>

      {Input ? (
        <Input
          icon='search'
          placeholder={t('rc_saved_search_placeholder')}
          value={search}
          onChange={(event) => onSearchChange?.(event.target.value)}
        />
      ) : (
        <input
          className='form-control mb-2'
          value={search}
          onChange={(event) => onSearchChange?.(event.target.value)}
          placeholder={t('rc_saved_search_placeholder')}
        />
      )}

      {reports.length === 0 ? (
        <p className='caption color-gray-600 mb-0'>
          {t('rc_saved_empty')}
        </p>
      ) : (
        <div className='report-saved-list'>
          {reports.map((report) => (
            <div key={report.id} className='report-saved-item'>
              <div>
                <p className='mb-1 fw-medium'>{report.name}</p>
                <p className='caption color-gray-600 mb-0'>
                  {t('rc_saved_updated', { date: formatDate(report.updatedAt) })}
                </p>
              </div>
              {Button ? (
                <Button
                  size='sm'
                  variant='secondary'
                  label={t('rc_saved_btn_load')}
                  onClick={() => onLoadReport(report.id)}
                />
              ) : (
                <button
                  type='button'
                  className='btn btn-sm btn-outline-secondary'
                  onClick={() => onLoadReport(report.id)}
                >
                  {t('rc_saved_btn_load')}
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      <div className='report-saved-pagination'>
        <span className='caption color-gray-600'>
          {t('rc_saved_pagination', { page, totalPages, total })}
        </span>
        <div className='d-flex gap-2'>
          {Button ? (
            <Button
              size='sm'
              variant='secondary'
              label={t('rc_saved_btn_prev')}
              onClick={() => onPageChange?.(page - 1)}
              disabled={!canGoPrev}
            />
          ) : (
            <button
              type='button'
              className='btn btn-sm btn-outline-secondary'
              onClick={() => onPageChange?.(page - 1)}
              disabled={!canGoPrev}
            >
              {t('rc_saved_btn_prev')}
            </button>
          )}
          {Button ? (
            <Button
              size='sm'
              variant='secondary'
              label={t('rc_saved_btn_next')}
              onClick={() => onPageChange?.(page + 1)}
              disabled={!canGoNext}
            />
          ) : (
            <button
              type='button'
              className='btn btn-sm btn-outline-secondary'
              onClick={() => onPageChange?.(page + 1)}
              disabled={!canGoNext}
            >
              {t('rc_saved_btn_next')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SavedReportsList;
